import { PlanDisplay } from './PlanCard';

export interface TherapistPlanGroups {
  avulso: PlanDisplay | null;
  pacotes: PlanDisplay[];
  subscriptions: PlanDisplay[];
}

const planLabel = (plan: PlanDisplay) =>
  `${plan.name} ${plan.title ?? ''}`.toLowerCase();

/** Separa planos de terapeuta em avulso, pacotes de horas e assinaturas. */
export function groupTherapistPlans(plans: PlanDisplay[]): TherapistPlanGroups {
  const avulso =
    plans.find((p) => /avulso/.test(planLabel(p)) || p.allowCustomQuantity) ?? null;

  const pacotes = plans.filter(
    (p) =>
      /pacote/.test(planLabel(p)) &&
      p.id !== avulso?.id &&
      !p.isRecurring
  );

  const usedIds = new Set(
    [avulso?.id, ...pacotes.map((p) => p.id)].filter(Boolean) as string[]
  );

  const subscriptions = plans.filter((p) => p.id && !usedIds.has(p.id));

  return { avulso, pacotes, subscriptions };
}
